import { Typography, IconButton, Box, Link } from "@mui/material";
import { IUser } from "@/redux/models";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from "react-router-dom";

const CompanyItem = ({ user }: { user: IUser }) => {
    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate(`/dashboard/empresas/ver?empresa=${user?.company?.id}`);
    };

    return user?.company != undefined ? (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link
                component="button"
                variant="body2"
                color="textSecondary"
                underline="hover"
                onClick={handleRedirect}
            >
                {user.company.nombre}
            </Link>
            <IconButton
                aria-label="Ver detalles"
                size="small"
                onClick={handleRedirect}
            >
                <OpenInNewIcon fontSize="inherit" />
            </IconButton>
        </Box>
    ) : <Typography color="textSecondary">Sin empresa</Typography>

}

export default CompanyItem;
